import {
  ProjectStateEvent,
  putV1CompaniesCompanyIdProjectsProjectIdActivate,
  putV1CompaniesCompanyIdProjectsProjectIdCancel,
  putV1CompaniesCompanyIdProjectsProjectIdComplete,
  putV1CompaniesCompanyIdProjectsProjectIdDeactivate,
  putV1CompaniesCompanyIdProjectsProjectIdDraft,
  putV1CompaniesCompanyIdProjectsProjectIdLose,
  putV1CompaniesCompanyIdProjectsProjectIdQuote,
} from '@treadinc/horizon-api-spec';

import { Project } from './models';

type TransitionFn =
  | typeof putV1CompaniesCompanyIdProjectsProjectIdActivate
  | typeof putV1CompaniesCompanyIdProjectsProjectIdCancel
  | typeof putV1CompaniesCompanyIdProjectsProjectIdComplete
  | typeof putV1CompaniesCompanyIdProjectsProjectIdDeactivate
  | typeof putV1CompaniesCompanyIdProjectsProjectIdDraft
  | typeof putV1CompaniesCompanyIdProjectsProjectIdLose
  | typeof putV1CompaniesCompanyIdProjectsProjectIdQuote;

const TRANSITION_FN_BY_EVENT: Record<ProjectStateEvent, TransitionFn> = {
  [ProjectStateEvent.ACTIVATE]: putV1CompaniesCompanyIdProjectsProjectIdActivate,
  [ProjectStateEvent.CANCEL]: putV1CompaniesCompanyIdProjectsProjectIdCancel,
  [ProjectStateEvent.COMPLETE]: putV1CompaniesCompanyIdProjectsProjectIdComplete,
  [ProjectStateEvent.DEACTIVATE]: putV1CompaniesCompanyIdProjectsProjectIdDeactivate,
  [ProjectStateEvent.DRAFT]: putV1CompaniesCompanyIdProjectsProjectIdDraft,
  [ProjectStateEvent.LOSE]: putV1CompaniesCompanyIdProjectsProjectIdLose,
  [ProjectStateEvent.QUOTE]: putV1CompaniesCompanyIdProjectsProjectIdQuote,
};

interface TransitionProjectArgs {
  companyId: string;
  event: ProjectStateEvent;
  projectId: string;
}

export async function transitionProject({
  companyId,
  event,
  projectId,
}: TransitionProjectArgs): Promise<Project> {
  const response = await TRANSITION_FN_BY_EVENT[event]({
    path: { 'company-id': companyId, 'project-id': projectId },
  });

  return Project.parse(response.data.data);
}
